var cache = {};
function _isImage(image) {
    return '[object HTMLImageElement]' === Object.prototype.toString.call(image);
}
function loadImage(url) {
    return new Promise(function (resolve, reject) {
        if (_isImage(url)) {
            resolve(url);
        }
        else if (/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(url)) {
            var canvas = document.createElement('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var context = canvas.getContext('2d');
            context.fillStyle = url;
            context.fillRect(0, 0, 1, 1);
            loadImage(canvas.toDataURL()).then(resolve);
        }
        else {
            if (cache[url]) {
                resolve(cache[url]);
                return;
            }
            var img_1 = new Image();
            img_1.setAttribute("crossOrigin", 'Anonymous');
            img_1.onload = function () {
                cache[url] = img_1;
                resolve(img_1);
            };
            img_1.onerror = reject;
            img_1.src = url;
        }
    });
}

export default loadImage;
//# sourceMappingURL=index.es.js.map
